module.exports = __webpack_public_path__ + "static/media/link--boomer-rewards.f9545889.png";